import { IELTData } from 'legacy/lut/classes/models/partner360/ELT/IELTData'
import { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { CloneVersionContent } from './CloneVersionContent'

interface IProps {
  show: boolean
  saveHandler: (selectedVersion: IELTData, versionName: string, versionSerialNumber: number) => void
  selectedVersion: IELTData
  onClose: () => void
}

export const CloneVersionDialog = ({ saveHandler, selectedVersion, show, onClose }: IProps) => {
  const contentProps = useMemo(
    () => ({
      selectedVersion,
      saveHandler,
    }),
    [saveHandler, selectedVersion]
  )

  return (
    <ModalDialog
      size={'xs'}
      content={CloneVersionContent}
      contentProps={contentProps}
      show={show}
      closeOnOutsideClick={false}
      onClose={onClose}
    />
  )
}
